export default __webpack_public_path__ + "loading.8a58e6d0.gif";